import { DASHBOARD_LOCALE_ES } from '@app/pages/dashboard/i18n/es';
import { AUTH_LOCALE_ES } from '@features/auth/i18n/es';
import { CUSTOMER_MANAGEMENT_LOCALE_ES } from '@features/customer/i18n/es';
import { DASHBOARD_KPIS_MANAGEMENT_LOCALE_ES } from '@features/dashboard-kpis/i18n/es';
import { CATALOG_SYNC_MANAGEMENT_LOCALE_ES } from '@features/catalog-sync/i18n/es';
import { EXCHANGE_RATE_MANAGEMENT_LOCALE_ES } from '@features/exchange-rate/i18n/es';
import { GROUP_MANAGEMENT_LOCALE_ES } from '@features/group/i18n/es';
import { HOTEL_MANAGEMENT_LOCALE_ES } from '@features/hotel/i18n/es';
import { MARKUP_MANAGEMENT_LOCALE_ES } from '@features/markup/i18n/es';
import { ORDER_MANAGEMENT_LOCALE_ES } from '@features/order/i18n/es';
import { PENDING_COLLECTION_MANAGEMENT_LOCALE_ES } from '@features/pending-collection/i18n/es';
import { PROVIDER_MANAGEMENT_LOCALE_ES } from '@features/provider/i18n/es';
import { PROVIDER_CALLS_LOCALE_ES } from '@features/provider-calls/i18n/es';
import { USER_MANAGEMENT_LOCALE_ES } from '@features/user/i18n/es';
import { UI_FILE_UPLOADER_LOCALE_ES } from '@shared/ui/ui-file-uploader/i18n/locale';
import { UI_PAGINATOR_LOCALE_ES } from '@shared/ui/ui-paginator/i18n/locale';
import { ILangVocab } from '../interface';
import { I18N_PARTIALS_ES } from '../partials/es';

export const locale: ILangVocab = {
  lang: 'es',
  data: {
    // Roles por su valor crudo, como los devuelve la API: la cabecera y la ficha
    // del perfil los traducen sin tener que mapear nada por el camino.
    ROLE: {
      ROLE_ADMIN: 'Administrador',
      ROLE_CUSTOMER: 'Cliente',
      ROLE_USER: 'Usuario',
    },
    CORE: {
      ROLE: {
        CUSTOMER: 'Cliente',
        ADMIN: 'Administrador',
        USER: 'Usuario',
      },
      GENDER: {
        MALE: 'Masculino',
        FEMALE: 'Femenino',
        INTERSEXUAL: 'Intersexual',
        OTHER: 'Otro',
      },
      THEME_COLOR: {
        DEFAULT: 'Inicial',
        BLUE: 'Azul',
        ORANGE: 'Naranja',
        RED: 'Rojo',
        VIOLET: 'Violeta',
        SLATE: 'Azul oscuro',
        GREEN: 'Verde',
        YELLOW: 'Amarillo',
      },
      THEME_MODE: {
        SYSTEM: 'Sistema',
        LIGHT: 'Claro',
        DARK: 'Oscuro',
      },
      THEME_TEMPLATE: {
        SIDEBAR: 'Barra lateral',
        TOPBAR: 'Barra superior',
      },
      USER_MENU: {
        PROFILE: 'Mi perfil',
        LANG: 'Idioma',
        LOGOUT: 'Salir',
        THEME: {
          LABEL: 'Tema',
          COLOR: 'Color',
          MODE: 'Modo',
          TEMPLATE: 'Plantilla',
        },
      },
      ERROR_PAGES: {
        NOT_FOUND: {
          TITLE: 'Página no encontrada',
          MESSAGE:
            '¡La página que buscas no se encontró! Revisa si la dirección es la correcta o contacta con los administradores si crees que es un error.',
        },
        SERVER_ERROR: {
          TITLE: 'Error del sistema',
          MESSAGE: '¡Algo salió mal! Por favor, inténtelo de nuevo más tarde.',
        },
        LAYOUT: {
          LOGO_ALT: 'Logo',
          GO_HOME_BUTTON: 'Ir a la página de inicio',
        },
      },
      USER_PROFILE: {
        HEADER: {
          LAST_LOGIN: 'Último acceso',
          MEMBER_SINCE: 'Alta en la plataforma',
        },
        TABS: {
          PROFILE: 'Perfil',
          SECURITY: 'Seguridad',
        },
        FIELD: {
          NAME: 'Nombre',
          EMAIL: 'Correo electrónico',
          EMAIL_VERIFIED: 'Verificado',
          EMAIL_UNVERIFIED: 'Sin verificar',
          MOBILE: 'Teléfono',
          ROLES: 'Roles',
          ROLES_FROM_GROUP: 'Heredados del grupo',
          GROUPS: 'Grupos',
          STATUS: 'Estado',
          STATUS_ENABLED: 'Activo',
          STATUS_DISABLED: 'Desactivado',
          NO_PASSWORD: 'sin contraseña propia (acceso con Google)',
          LAST_LOGIN: 'Último acceso',
          CREATED_AT: 'Alta',
          UPDATED_AT: 'Última modificación',
          LOCALE: 'Idioma',
          DNI: 'Documento de identidad',
          NATIONALITY: 'Nacionalidad',
          GENDER: 'Género',
          BIRTHDATE: 'Fecha de nacimiento',
        },
        BREADCRUMB: 'Perfil',
        OVERVIEW: {
          TITLE: 'Detalles',
        },
        CHANGE_PASSWORD: {
          TITLE: 'Cambiar contraseña',
          CURRENT_PASSWORD_LABEL: 'Contraseña actual',
          NEW_PASSWORD_LABEL: 'Contraseña nueva',
          CURRENT_PASSWORD_MISMATCH: 'La contraseña actual no coincide.',
          SUCCESS_TITLE: 'Ha cambiado tu contraseña',
          SUCCESS_MESSAGE:
            'Tu contraseña se ha cambiado. Te llevamos a la página de inicio.',
        },
      },
    },
    NAV: {
      GROUP: {
        OPERATION: 'Operación',
        HOTELBEDS: 'Hotelbeds',
        SETTINGS: 'Ajustes',
      },
      DASHBOARD: 'Panel',
      CATALOG: 'Catálogo',
      ARIA: 'Menú del back office',
      TAG: 'Back office',
      MENU: 'Menú',
      CLOSE: 'Cerrar',
      SKIP: 'Saltar al contenido',
      HOME_ARIA: 'IBSOA Travel, back office, panel',
      LOGOUT: 'Cerrar sesión',
      FOOTER: 'Back office de IBSOA Travel, solo para uso interno',
      FOOTER_PROVIDER_CALLS: 'Estado de las llamadas a Hotelbeds',
      FOOTER_WEB: 'Ver la web pública',
    },
    TEXT: {
      MANAGEMENT: 'Gestión',
      ADMINISTRATION: 'Administración',
      SELECT: 'Seleccionar',
      PLEASE_WAIT: 'Un momento',
      LOADING: 'Cargando…',
      ONLINE_MESSAGE: 'Tu conexión a internet fue restaurada.',
      OFFLINE_MESSAGE: 'No estas conectado a internet.',
      NO_DATA: 'Todavía no hay nada aquí.',
      NO_ITEMS_FOUND: 'No se encontraron elementos',
    },
    ...I18N_PARTIALS_ES,
    ...UI_PAGINATOR_LOCALE_ES,
    ...UI_FILE_UPLOADER_LOCALE_ES,
    ...AUTH_LOCALE_ES,
    ...USER_MANAGEMENT_LOCALE_ES,
    ...CUSTOMER_MANAGEMENT_LOCALE_ES,
    ...GROUP_MANAGEMENT_LOCALE_ES,
    ...ORDER_MANAGEMENT_LOCALE_ES,
    ...PENDING_COLLECTION_MANAGEMENT_LOCALE_ES,
    ...HOTEL_MANAGEMENT_LOCALE_ES,
    ...MARKUP_MANAGEMENT_LOCALE_ES,
    ...PROVIDER_MANAGEMENT_LOCALE_ES,
    ...EXCHANGE_RATE_MANAGEMENT_LOCALE_ES,
    ...DASHBOARD_KPIS_MANAGEMENT_LOCALE_ES,
    ...DASHBOARD_LOCALE_ES,
    ...CATALOG_SYNC_MANAGEMENT_LOCALE_ES,
    ...PROVIDER_CALLS_LOCALE_ES,
  },
};
